<template>
  <div v-if="$globalConfig.APP_NAME === 'senso'">
    <v-img v-if="$vuetify.breakpoint.mdAndUp"
      :src="isQuickResource ? '/static/resources/senso-learn-quick-resources-banner-desktop.png' : '/static/resources/senso-resource-desktop-banner.png'"
      alt="quick start banner" @load="onImageLoad">
      <div :class="['header-text', isQuickResource ? 'quick-start-header-text' : '']" v-if="imageLoaded">
        <h1>{{ title }}</h1>
        <p>{{ subTitle }}</p>
      </div>
    </v-img>
    <!-- Tablet Image -->
    <v-img v-else-if="$vuetify.breakpoint.smAndUp && $vuetify.breakpoint.smAndDown"
      :src="isQuickResource ? '/static/resources/senso-learn-quick-resources-banner-tablet.png' : '/static/resources/senso-resource-tablet-banner.png'"
      alt="quick start banner" @load="onImageLoad">
      <div :class="['header-text', isQuickResource ? 'quick-start-header-text' : '']" v-if="imageLoaded">
        <h1>{{ title }}</h1>
        <p>{{ subTitle }}</p>
      </div>
    </v-img>
    <!-- Mobile Image -->
    <v-img v-else
      :src="isQuickResource ? '/static/resources/senso-learn-quick-resources-banner-mobile.png' : '/static/resources/senso-resource-mobile-banner.png'"
      alt="quick start banner" @load="onImageLoad">
      <div :class="['header-text', isQuickResource ? 'quick-start-header-text' : '']" v-if="imageLoaded">
        <h1>{{ title }}</h1>
        <p>{{ subTitle }}</p>
      </div>
    </v-img>
  </div>
  <div v-else>
    <v-img v-if="$vuetify.breakpoint.mdAndUp"
      :src="isQuickResource ? '/static/resources/improve-quick-start-desktop-banner.png' : '/static/resources/resource-desktop-banner.png'"
      alt="quick start banner" @load="onImageLoad">
      <div :class="['header-text', isQuickResource ? 'quick-start-header-text' : '']"  v-if="imageLoaded">
        <h1>{{ title }}</h1>
        <p>{{ subTitle }}</p>
      </div>
    </v-img>
    <!-- Tablet Image -->
    <v-img v-else-if="$vuetify.breakpoint.smAndUp && $vuetify.breakpoint.smAndDown"
      :src="isQuickResource ? '/static/resources/improve-quick-start-tablet-banner.png' : '/static/resources/resource-tablet-banner.png'"
      alt="quick start banner" @load="onImageLoad">
      <div :class="['header-text', isQuickResource ? 'quick-start-header-text' : '']"  v-if="imageLoaded">
        <h1>{{ title }}</h1>
        <p>{{ subTitle }}</p>
      </div>
    </v-img>
    <!-- Mobile Image -->
    <v-img v-else
      :src="isQuickResource ? '/static/resources/improve-quick-start-mobile-banner.png' : '/static/resources/resource-mobile-banner.png'"
      alt="quick start banner" @load="onImageLoad">
      <div :class="['header-text', isQuickResource ? 'quick-start-header-text' : '']"  v-if="imageLoaded">
        <h1>{{ title }}</h1>
        <p>{{ subTitle }}</p>
      </div>
    </v-img>
  </div>

</template>

<script>
export default {
  name: 'HeaderComponent',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    isQuickResource: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imageLoaded: false, // Track whether the image has fully loaded
    };
  },
  methods: {
    onImageLoad() {
      this.imageLoaded = true; // Set to true when the image is loaded
    }
  }
}
</script>

<style scoped>
.header-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  text-align: center;
}

.quick-start-header-text {
  position: relative;
}

/* Responsive adjustments for mobile */
@media (max-width: 768px) {
  .header-text h1 {
    font-size: 24px;
    /* Smaller font for tablets or medium devices */
  }

  .header-text p {
    font-size: 14px;
    /* Smaller font for tablets or medium devices */
  }
}

@media (max-width: 480px) {
  .header-text h1 {
    font-size: 18px;
    /* Even smaller font for mobile phones */
  }

  .header-text p {
    font-size: 12px;
    /* Smaller font for mobile phones */
  }
}
</style>